export const loadNavFAM_selectUtil = (data) => {
    return data ? data : null
}